import React, { useContext, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { yupResolver } from '@hookform/resolvers/yup'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { strikeSchema } from '../../../util/validationSchema'
import { addStrike } from '../../../redux/slices/cleanersSlice'

const AddStrike = ({ toggleStrikeModal, setIsRefresh, cleaner_id }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const { handleSubmit, control, trigger, setValue } = useForm({
    resolver: yupResolver(strikeSchema),
    defaultValues: {}
  })

  useEffect(() => {
    setValue('cleaners_id', cleaner_id)
  }, [cleaner_id])

  const onSubmit = (data) => {
    changeLoader(true)
    setIsRefresh(false)
    dispatch(addStrike(data)).then(({ payload, error }) => {
      if (payload?.status === 200 || payload?.status === 201) {
        setIsRefresh(true)
        changeLoader(false)
        successToast(payload?.data?.status_message || 'Success!')
        toggleStrikeModal()
      } else {
        errorToast(payload?.data?.status_message || error?.message)
        changeLoader(false)
      }
    })
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group">
              <label>
                Reason<span className="text-danger"></span>
              </label>
              <Controller
                name={`reason`}
                control={control}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <input
                      className="form-control"
                      value={value}
                      type="text"
                      placeholder="Enter Reason"
                      onChange={(val) => {
                        onChange(val)
                        trigger(`reason`)
                      }}
                    />
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
                defaultValue=""
              />
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleStrikeModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              {`Save`}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddStrike
